<template>
	<div class="customSelect mdb-select md-form float-field form-control" @click.prevent="$parent.selectAccount = !$parent.selectAccount" :class="($parent.selectAccount?'active' : '') || (($parent.account_id == '' && $parent.submitted)?'is-invalid' : '')">
		<div class="SelectAcntList">
			<div class="d-flex align-items-center justify-content-between" v-if="$parent.account_id == ''">
			
				<p v-if="$parent.pageName == 'Internal-transfer'">{{$t('accId_TransFromAccId')}}</p><p v-else>{{$t('accId_selectAccountId')}}</p>
			</div>
			<div class="d-flex align-items-center justify-content-between" v-else>
				<span v-if="getWallet($parent.account_id)">
					<img :src="'../../../../static/fxView/images/'+getWallet($parent.account_id).wallet.currency.toLowerCase()+'.svg'" class="mr-2" alt="Icon">
					{{getWallet($parent.account_id).wallet.wallet_no}} 
				</span>
				<span v-else>
					<img :src="'../../../../static/fxView/images/'+$env_var.platformIcon[$parent.platform]" class="mr-2" alt="Icon">
					{{$parent.account_id}} 
				</span>
				<small v-html="(parseInt($parent.demo_live) == 1)? $t('live') : $t('demo') "></small>
			</div>
		</div>
		<!-- <ul class="scrollbar dropNameADd" v-if="$parent.pageName == 'Remove-Bonus' || $parent.pageName == 'Bonus'">
			<li class="headnameSelect d-flex align-items-center justify-content-between">
        		<span>Platform</span> 
        		<span>Account ID</span>
        		<span>Leverage</span>
        		<span>Currency</span>
        		<span>Account Type</span>
        	</li>
        	<li v-for="(list,key) in tradingAccountList.records" v-if="(parseInt(list.demo_live) == 1 && list.account_id != $parent.to_account_id)" @click.prevent="asignValueParentComponent(list)">
                <div class="aclist">
                    <span>
                    	<img  :src="'../../../../static/fxView/images/'+$env_var.platformIcon[list.platform]" alt="Icon" class="mr-2" />
                    </span> 
                    <span>{{list.account_id}}  </span> 
                    <span>{{list.leverage}}</span>
                    <span>{{list.currency}}</span>
                    <span v-html="(parseInt(list.demo_live) == 1)? $t('live') : $t('demo') "></span>
                </div>
            </li>
		</ul> -->
		<ul class="scrollbar" v-if="$parent.pageName == 'Internal-transfer'">
			<li v-for="(list,key) in tradingAccountList.records" v-if="(parseInt(list.demo_live) == 1 && list.account_id != $parent.to_account_id)" @click.prevent="asignValueParentComponent(list)">
				<div class="aclist" > 
					<span>
						<img :src="'../../../../static/fxView/images/'+$env_var.platformIcon[list.platform]" class="mr-2"  alt="Icon"> {{list.account_id}}  
					</span>
					<small v-html="(parseInt(list.demo_live) == 1)? $t('live') : $t('demo') "></small>
				</div>
			</li>
		</ul>
		<ul class="scrollbar" v-else-if="$parent.pageName == 'Change-Password' || $parent.pageName == 'Change-Leverage'">
			<li v-for="(list,key) in tradingAccountList.records" @click.prevent="asignValueParentComponent(list)">
				<div class="aclist" > 
					<span>
						<img :src="'../../../../static/fxView/images/'+$env_var.platformIcon[list.platform]" class="mr-2"  alt="Icon"> {{list.account_id}}  
					</span>
					<small v-html="(parseInt(list.demo_live) == 1)? $t('live') : $t('demo') "></small>
				</div>
			</li>
		</ul>
		<ul class="scrollbar" v-else-if="$parent.pageName == 'subscription-chnage-account'">
			<li v-for="(list,key) in allAccountList.records" @click.prevent="asignValueParentComponent(list)" v-if="parseInt(list.demo_live) == 1" >
				<div class="aclist" v-if="list.margin_detail"> 
					<span>
						<img :src="'../../../../static/fxView/images/'+list.currency.toLowerCase()+'.svg'" class="mr-2"  alt="Icon"> {{list.wallet_no}}  
					</span>
				</div>
				<div class="aclist" v-else> 
					<span>
						<img :src="'../../../../static/fxView/images/'+$env_var.platformIcon[list.platform]" class="mr-2"  alt="Icon"> {{list.account_id}}  
					</span>
					<small v-html="(parseInt(list.demo_live) == 1)? $t('live') : $t('demo') "></small>
				</div>
			</li>
		</ul>
		<ul class="scrollbar" v-else>
			<li v-for="(list,key) in tradingAccountList.records" v-if="parseInt(list.demo_live) == 1" @click.prevent="asignValueParentComponent(list)">
				<div class="aclist" > 
					<span>
						<img :src="'../../../../static/fxView/images/'+$env_var.platformIcon[list.platform]" class="mr-2"  alt="Icon"> {{list.account_id}}  
					</span>
					<small v-html="(parseInt(list.demo_live) == 1)? $t('live') : $t('demo') "></small>
				</div>
			</li>
		</ul>
		<p class="error" v-if="($parent.submitted && $parent.account_id == '')">{{$t('accId_fieldReq')}}</p>
	</div>
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
    export default {
        name: 'Account-Id',
        mixins: [fxViewMixins],
        data() {
            return {
            }
        },
        methods:{
        	getWallet(account_id){// to check if the trading account_id is wallet also return wallet id and also need to get wallet id and currency
        		try{
	        		let data = Object.values(this.walletAccount).filter(val=> val.wallet.account_id == account_id )
	        		return (data.length)?data[0]:''
        		}catch(e){return '';}
        	},
            asignValueParentComponent(list){
				this.$parent.account_id = list.account_id 
				this.$parent.act_account_id = list.act_account_id  
				this.$parent.demo_live = list.demo_live 
				this.$parent.platform = list.platform 
				if(this.$parent.pageName && this.$parent.pageName == 'Change-Leverage'){
					this.$parent.exsisting_leverage = list.leverage
					this.$parent.leverage =	 ''				
				}else if((this.$parent.pageName) && (this.$parent.pageName == 'Bonus' || this.$parent.pageName == 'Remove-Bonus')){
					this.$parent.leverage = list.leverage 
					this.$parent.tradingBonus() 
				}else if(this.$parent.pageName && (this.$parent.pageName == 'Withdrawal' || this.$parent.pageName == 'auto_chartist_subscription')){
					this.$parent.currencyData = list.currency 
					this.$parent.tradingAcountSelect() 
				}else if(this.$parent.pageName && this.$parent.pageName == 'Internal-transfer'){
					this.$parent.tradingBonus('from') 
					this.$parent.from_currency = list.currency
				}
		    }
        },
		mounted() { 
			const _that = this
            $(document).on("click", function(event){
				if(!$(event.target).closest('.SelectAcntList').length){
                    _that.$parent.selectAccount = false
                }
            });
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/shared/tradingAccounts/account_id.vue